const routerBox = {
  name: 'routerBox',
  render() {
    return <router-view />
  },
}
const securityRoute = '/productManage/security/index'

export default {
  path: 'security',
  name: 'security',
  component: routerBox,
  meta: {
    title: '安防监控',
  },
  redirect: '/productManage/security/index',
  children: [
    {
      path: 'index',
      name: 'security-index',
      component: () => import('@/views/retailTraffic/home/index.vue'),
      meta: {
        level: 0,
      },
    },
    {
      path: 'config',
      name: 'security-config',
      component: () => import('@/views/retailTraffic/config/index.vue'),
      meta: {
        title: '门店分配',
        activeMenu: securityRoute,
      },
      hidden: true,
    },
    {
      path: 'device',
      name: 'security-device',
      component: routerBox,
      redirect: '/productManage/security/device/index',
      hidden: true,
      meta: {
        title: '设备管理',
      },
      children: [
        {
          path: 'index',
          name: 'security-device-index',
          component: () => import('@/views/retailTraffic/device/index.vue'),
          meta: {
            activeMenu: securityRoute,
          },
        },
        {
          path: 'check',
          name: 'security-device-check',
          component: () => import('@/views/retailTraffic/device/check.vue'),
          meta: {
            title: '查看',
            activeMenu: securityRoute,
          },
        },
        {
          path: 'live',
          name: 'security-device-live',
          component: () => import('@/views/live/index.vue'),
          meta: {
            title: '直播',
            activeMenu: securityRoute,
          },
        },
        {
          path: 'cameraManage',
          name: 'security-device-cameraManage',
          component: routerBox,
          meta: {
            title: '摄像头管理',
            breadcrumbHideWhen(currentRoute) {
              return currentRoute.query.from === 'device'
            }
          },
          redirect: '/productManage/security/device/cameraManage/index',
          children: [
            {
              path: 'index',
              name: 'security-device-cameraManage',
              component: () => import('@/views/security/device/cameraManage/index.vue'),
              meta: {
                activeMenu: securityRoute,
              },
            },
            {
              path: 'live',
              name: 'security-device-cameraManage-live',
              component: () => import('@/views/live/index.vue'),
              meta: {
                title: '直播',
                activeMenu: securityRoute,
              },
            },
            {
              path: 'setting',
              name: 'security-device-cameraManage-setting',
              component: () => import('@/views/retailTraffic/device/cameraManage/setting.vue'),
              meta: {
                title: '设置',
                activeMenu: securityRoute,
              },
            },
            {
              path: 'update',
              name: 'security-device-cameraManage-update',
              component: () => import('@/views/box/retailTraffic/change.vue'),
              meta: {
                title: '更换',
                activeMenu: securityRoute,
              },
            },
          ],
        },
      ],
    },
    {
      path: 'solution',
      name: 'security-solution',
      component: () => import('@/views/retailTraffic/solution/index.vue'),
      hidden: true,
      meta: {
        title: '新建解决方案',
        activeMenu: securityRoute,
      },
    },
    {
      path: 'cameraManage',
      name: 'security-cameraManage',
      component: routerBox,
      meta: {
        title: '摄像头管理',
      },
      hidden: true,
      redirect: '/productManage/security/cameraManage/index',
      children: [
        {
          path: 'index',
          name: 'security-cameraManage',
          component: () => import('@/views/security/device/cameraManage/index.vue'),
          meta: {
            activeMenu: securityRoute,
          },
        },
        {
          path: 'live',
          name: 'security-cameraManage-live',
          component: () => import('@/views/live/index.vue'),
          meta: {
            title: '直播',
            activeMenu: securityRoute,
          },
        },
        {
          path: 'update',
          name: 'security-cameraManage-update',
          component: () => import('@/views/box/retailTraffic/change.vue'),
          meta: {
            title: '更换',
            activeMenu: securityRoute,
          },
        },
      ],
    },
  ],
}
